import { PropertyId } from "./PropertyId";
import { PropertyCategoryId } from "./PropertyCategoryId";
import PropertyItemTypeEnum from "./PropertyItemTypeEnum";
import PropertyTranslator, { PropertySelectionOption } from "./PropertyTranslator";

// Untyped "row" shape the UI/query pipeline consumes. PropertyItem<T> IS this surface directly
// (TS structural typing makes a separate PropertyItemBase interface unnecessary).
export default class PropertyItem<T> {
    id: PropertyId;
    translator: PropertyTranslator<T>;

    // Set by declaration code right after construction (mirrors PropertyItem(id, translator)
    // followed by `.value = ...` / `.categoryId = ...` in getProperties()).
    categoryId!: PropertyCategoryId;
    value!: T;

    sortOrder: number = 0;
    parentId?: PropertyId;
    readOnly: boolean = false;
    visible: boolean = true;
    dirty: boolean = false;
    varying: boolean = false;

    constructor(id: PropertyId, translator: PropertyTranslator<T>) {
        this.id = id;
        this.translator = translator;
    }

    getItemType(): PropertyItemTypeEnum {
        return this.translator.getItemType();
    }

    getDisplayValue(): string {
        return this.translator.getDisplayValue(this.value);
    }

    // Returns false on parse/validation failure; caller should revert the UI's displayed value.
    setDisplayValue(text: string): boolean {
        const result = this.translator.setValue(text);
        if (!result.ok) return false;

        this.value = result.value;
        this.dirty = true;
        return true;
    }

    usesButton(): boolean {
        return this.translator.usesButton();
    }

    onButton(): void {
        if (!this.translator.onButton) return;

        const next = this.translator.onButton(this.value);
        if (next !== undefined) {
            this.value = next;
            this.dirty = true;
        }
    }

    getListType(): 'none' | 'combo' | 'list' {
        return this.translator.getListType();
    }

    getSelectionOptions(): PropertySelectionOption<T>[] | undefined {
        return this.translator.getSelectionOptions?.();
    }
}
